import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { ComboService } from '../../Model/Combo/combo.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { SessionService } from '../../Util/Session/session.service';

@Component({
  selector: 'app-company-employee-details',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule],
  templateUrl: './company-employee-details.component.html',
  styleUrl: './company-employee-details.component.scss'
})
export class CompanyEmployeeDetailsComponent {
  CompanyDetails: any[] = [];
  isDisabled: boolean = false;
  EmpMasterId: number = 0;
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  ClientId: number = 0;
  ClientName: string = '';
  SiteId: number = 0;
  SiteName: string = '';
  SiteCode: string = '';
  DutyId: number = 0;
  Duty: string = '';
  DutyLoad: any[] = [];
  DesignationLoad: any[] = [];
  Designation: string = '';
  DesignationId: number = 0;
  DepartmentLoad: any[] = [];
  DepartmentID: number = 0;
  DepartmentName: string = '';
  UserLoad: any[] = [];
  ShiftTitle: string = '';
  ShiftID: number = 0;
  Shift: any[] = [];
  SalaryLoad: any[] = [];
  SalaryID: number = 0;
  SalaryName: string = '';
  StatusLoad: any[] = [];
  WorkingStatusLoad: any[] = [];
  BranchId: number = 0;
  EmpType: string = '';
  MetroCity: number = 1;
  AutoTDSFlag: number = 1;
  Report1ID: number = 0;
  Report2ID: number = 0;
  PresentStatusId: number = 0;
  StatusMasterDate: string = '';
  OfficeEmail: string = '';
  ContractStartDate: string = ''
  ContractEndDate: string = ''
  ProbationDate: string = '';
  JoningDate: string = '';

  public User: any = null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private comboload: ComboService,
    private modalService: NgbModal,
    private employeeRegistration: EmployeeRegistrationService,
    private sessionService: SessionService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.EmpMasterId = parseInt(params['id']));
    this.User = this.sessionService.GetUserDetails();
  }

  ngOnInit(): void {
    this.GetData();
    this.ComboLoad('Client');
    this.ComboLoad('GetEssDepartmentMaster');
    this.ComboLoad('GetEssUserMaster');
    this.ComboLoad('shift');
    this.ComboLoad('SalaryStructure');
    this.ComboLoad('PresentStatus');
    this.ComboLoad('StatusMaster');
    if (this.EmpMasterId > 0) {
      console.log('Employee ID', this.EmpMasterId);
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      this.router.navigate(['/onboarding/register/']);
    }
  }

  GetData() {
    const data = {
      SelectType: 'U',
      EmpMasterId: this.EmpMasterId,
      UserId: this.User.UserId
    }
    this.isDisabled = true;
    this.employeeRegistration.CompanyEmployeeDetailsSelect(data).subscribe(
      data => {
        this.CompanyDetails = Object.values(data.Table);
        console.log('new data', this.CompanyDetails);
        if (this.CompanyDetails.length > 0) {
          this.ClientId = this.CompanyDetails[0].ClientId;
          this.ComboLoad('Site');
          this.SiteId = this.CompanyDetails[0].SiteId;
          this.ComboLoad('Designation');
          this.SalaryID = this.CompanyDetails[0].SalaryStructureId;
          this.DesignationId = this.CompanyDetails[0].DesignationId;
          this.ComboLoad('Duty');
          this.DutyId = this.CompanyDetails[0].DutyId;
          this.DepartmentID = this.CompanyDetails[0].DepartmentId;
          this.Report1ID = this.CompanyDetails[0].ReportingManagerId1;
          this.Report2ID = this.CompanyDetails[0].ReportingManagerId2;
          this.ShiftID = this.CompanyDetails[0].ShiftId;
          this.PresentStatusId = this.CompanyDetails[0].PresentStatusId;
          this.ContractStartDate = this.convertDateStringToObject(this.CompanyDetails[0].ContractStartDate);
          this.ContractEndDate = this.convertDateStringToObject(this.CompanyDetails[0].ContractEndDate);
          this.JoningDate = this.convertDateStringToObject(this.CompanyDetails[0].JoiningDate);
          this.ProbationDate = this.convertDateStringToObject(this.CompanyDetails[0].ProbationDate);
          this.StatusMasterDate = this.convertDateStringToObject(this.CompanyDetails[0].StatusDate);
          this.OfficeEmail = this.CompanyDetails[0].OfficialEmail;
          this.AutoTDSFlag = this.CompanyDetails[0].AutoTDS;
          this.MetroCity = this.CompanyDetails[0].Metrocity;
          this.EmpType = this.CompanyDetails[0].EmpType;
        }
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      'DesignationId': (Combotype == 'Duty') ? this.DesignationId : 0,
      'EmpType': this.EmpType
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        } else if (Combotype == 'Designation') {
          this.DesignationLoad = response.ComboLoad;
        } else if (Combotype == 'Duty') {
          this.DutyLoad = response.ComboLoad;
        } else if (Combotype == 'GetEssDepartmentMaster') {
          this.DepartmentLoad = response.ComboLoad;
        } else if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad;
        } else if (Combotype == 'shift') {
          this.Shift = response.ComboLoad;
        } else if (Combotype == 'SalaryStructure') {
          this.SalaryLoad = response.ComboLoad;
        } else if (Combotype == 'StatusMaster') {
          this.StatusLoad = response.ComboLoad;
        } else if (Combotype == 'PresentStatus') {
          this.WorkingStatusLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  onSelectChange(type: string) {
    if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = 0
      this.DesignationId = 0,
        this.Designation = ''
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
      this.DesignationId = 0,
        this.Designation = ''
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type === 'Duty') {
      const selected = this.DutyLoad.find(duty => duty.DutyMasterID === this.DutyId);
      this.Duty = selected ? selected.DutyName : null;
    }
    else if (type === 'Designation') {
      const selected = this.DesignationLoad.find(designation => designation.DesignationMasterID === this.DesignationId);
      this.Designation = selected ? selected.DesignationName : null;
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type === 'Shift') {
      const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
      this.ShiftTitle = selected ? selected.ShiftTitle : null;
    }
    else if (type === 'Salary') {
      const selected = this.SalaryLoad.find(sal => sal.CategoryMasterID === this.SalaryID);
      this.SalaryName = selected ? selected.CategoryName : null;
    }
    else if (type === 'Department') {
      const selected = this.DepartmentLoad.find(sal => sal.DepartmentMasterID === this.DepartmentID);
      this.DepartmentName = selected ? selected.DepartmentName : null;
    }
  }

  async Save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  InsertUpdate() {
    if (this.Report1ID === this.Report2ID && this.Report1ID > 0) {
      this.toast.show({ message: "Both the Reporting Approval cannot be same for Employee!", type: toastTypeEnum.danger });
      return;
    }
    if (this.Report1ID === 0 && this.Report2ID > 0) {
      this.toast.show({ message: "Please select Reporting Approval1 for Employee ", type: toastTypeEnum.danger });
      return;
    }
    const CompanyData = {
      SelectType: 'U',
      EmpMasterId: this.EmpMasterId,
      EmpType: this.EmpType,
      BranchId: this.BranchId,
      DutyId: this.DutyId,
      DesignationId: this.DesignationId,
      SalaryStructureId: this.SalaryID,
      JoiningDate: this.formatDateObject(this.JoningDate),//this.JoningDate,
      ProbationDate: this.formatDateObject(this.ProbationDate),
      MetroCity: this.MetroCity,
      AutoTDSFlag: this.AutoTDSFlag,
      ContractStartDate: this.EmpType === 'Front' ? this.formatDateObject(this.ContractStartDate) : '',
      ContractEndDate: this.EmpType === 'Front' ? this.formatDateObject(this.ContractEndDate) : '',
      ReportingManagerId1: this.Report1ID,
      ReportingManagerId2: this.Report2ID,
      ShiftMasterId: this.ShiftID,
      WorkStatusId: this.PresentStatusId,
      Statusdate: this.formatDateObject(this.StatusMasterDate),
      OfficialEmail: this.EmpType === 'Back' ? this.OfficeEmail : '',
      DepartmentId: this.DepartmentID,
      By: this.User.UserId
    };

    this.isDisabled = true;
    this.employeeRegistration.CompanyEmployeeDetailsInserUpdate(CompanyData).subscribe(
      data => {
        if (data.Error_Code == 348) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
          this.isDisabled = false;
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }

  formatDateObject(statusDate: any): string | null {
    const { day, month, year } = statusDate;
    if (day && month && year) {
      // const date = new Date(year, month - 1, day);
      const formattedDate = this.formatDay(day) + ' ' + this.getMonthName(month) + ' ' + year;
      return formattedDate;
    } else {
      return null;
    }
  }
  private formatDay(day: number): string {
    return day < 10 ? '0' + day : day.toString();
  }
  private getMonthName(month: number): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[month - 1];
  }
  convertDateStringToObject(dateString: string): any {
    const parts = dateString.split(' ');
    const day = parseInt(parts[0], 10);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames.findIndex(name => name === parts[1]) + 1;
    const year = parseInt(parts[2], 10);

    return {
      day: day,
      month: month,
      year: year
    };
  }

  close(){
    this.router.navigate(['onboarding/register']);
  }
}
